import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Board as BoardIcon } from "@air/next-icons";
import pluralize from "pluralize";
import { memo, useCallback, useMemo } from "react";
export const BoardMetaData = /*#__PURE__*/ memo((param)=>{
    let { itemCount } = param;
    const itemCountPhrase = useMemo(()=>{
        // itemCount will be undefined when a new board is created in Table View
        const count = itemCount !== null && itemCount !== void 0 ? itemCount : 0;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                " \xb7 ",
                pluralize("item", count, true)
            ]
        });
    }, [
        itemCount
    ]);
    // Prevents the button from triggering selection of the row when clicking on the button.
    const onMouseDown = useCallback((event)=>{
        event.stopPropagation();
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        className: "pointer-events-none -ml-1 flex items-center gap-1",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "pointer-events-none flex h-5 min-w-0 items-center gap-1 rounded px-1 text-12 font-semibold text-grey-11 hover:bg-grey-3",
            "data-disableselect": "true",
            onMouseDown: onMouseDown,
            children: [
                /*#__PURE__*/ _jsx(BoardIcon, {
                    className: "size-3 shrink-0"
                }),
                /*#__PURE__*/ _jsxs("span", {
                    className: "truncate",
                    children: [
                        "Board",
                        itemCountPhrase
                    ]
                })
            ]
        })
    });
});
BoardMetaData.displayName = "BoardMetaData";
